
    <template>
      <section class="content element-doc">
        <h2 id="xia-zai-excel"><a class="header-anchor" href="#xia-zai-excel">¶</a> 下载 Excel</h2>
<h3 id="yin-ru"><a class="header-anchor" href="#yin-ru">¶</a> 引入</h3>
<pre><code class="language-js">import { downloadExcel, downloadGroupsExcel, downloadColExcel, downloadGroupsColExcel } from 'sh-ui-v2'
</code></pre>
<h3 id="ji-chu-biao-ge"><a class="header-anchor" href="#ji-chu-biao-ge">¶</a> 基础表格</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;download-excel&quot;&gt;
    &lt;div class=&quot;btn-box&quot;&gt;
      &lt;el-button @click=&quot;onDownload&quot;&gt;下载&lt;/el-button&gt;
    &lt;/div&gt;
    &lt;sh-table :data=&quot;tableData&quot; :pageShow=&quot;false&quot; border&gt;
      &lt;el-table-column v-for=&quot;item in headerColumns&quot; :key=&quot;item.key&quot; :field=&quot;item.key&quot; :label=&quot;item.name&quot; :prop=&quot;item.key&quot;&gt;
      &lt;/el-table-column&gt;
    &lt;/sh-table&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  const { downloadExcel } = require('#/utils/xlsx.js')
  export default {
    name: 'downloadExcel',
    data() {
      return {
        tableData: [
          { name: '张三', age: 4, sex: '男' },
          { name: '李四', age: 19, sex: '男' },
          { name: '王五', age: 20, sex: '男' }
        ],
        headerColumns: [
          {
            name: '姓名',
            key: 'name'
          },
          {
            name: '年龄',
            key: 'age'
          },
          {
            name: '性别',
            key: 'sex'
          }
        ]
      }
    },
    methods: {
      onDownload() {
        downloadExcel({ tableData: this.tableData, columns: this.headerColumns, fileName: '表格', styleCallback: this.styleCallback })
      },
      styleCallback(worksheet) {
        // 设置数据单元格样式
        worksheet.eachRow((row, rowNum) =&gt; {
          // 第1行为表头行
          if (rowNum === 1) {
            this.renderTableHeader(row)
          } else if (rowNum === 3) {
            // 假设第三行是统计行，单独给这一行背景色用来区别
            row.eachCell((cell, rowNumber) =&gt; {
              // 设置单元格背景
              cell.fill = {
                type: 'pattern',
                pattern: 'darkVertical',
                fgColor: { argb: '8FBC8F' },
                bgColor: { argb: '8FBC8F' }
              }
              this.renderCell(cell)
            })
          } else {
            row.eachCell((cell, colNum) =&gt; {
              this.renderCell(cell)
            })
          }
        })
      },
      // 设置表头自定义样式
      renderTableHeader(row) {
        // 文本样式
        row.font = {
          color: { argb: 'DC143C' },
          bold: true
        }
        // 文本居中
        row.alignment = { horizontal: 'center' }
        // 设置表头列表
        row.eachCell((cell, cellNum) =&gt; {
          // 单元格背景
          cell.fill = {
            type: 'pattern',
            pattern: 'darkTrellis',
            fgColor: { argb: 'DEB887' },
            bgColor: { argb: 'DEB887' }
          }
          // 单元格边框
          cell.border = {
            top: { style: 'double', color: { argb: 'FF00FF00' } },
            left: { style: 'double', color: { argb: 'FF00FF00' } },
            bottom: { style: 'double', color: { argb: 'FF00FF00' } },
            right: { style: 'double', color: { argb: 'FF00FF00' } }
          }
        })
      },
      // 正常数据单元格的样式处理
      renderCell(cell) {
        // 将age属性做特殊处理，大于5的值用红色显示，其它用绿色显示
        if (cell._column._key === 'age') {
          if (cell.value &lt;= 5) {
            cell.font = {
              color: { argb: '7FFF00' },
              bold: true
            }
          } else {
            cell.font = {
              color: { argb: 'DC143C' },
              bold: true
            }
          }
        }
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="biao-tou-fen-zu-biao-ge"><a class="header-anchor" href="#biao-tou-fen-zu-biao-ge">¶</a> 表头分组表格</h3>
<div class="tip">
<p>需严格按照示例格式进行配置</p>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;download-excel&quot;&gt;
    &lt;div class=&quot;btn-box&quot;&gt;
      &lt;el-button @click=&quot;onDownload&quot;&gt;下载&lt;/el-button&gt;
    &lt;/div&gt;
    &lt;sh-table :data=&quot;tableData&quot; :pageShow=&quot;false&quot;&gt;
      &lt;el-table-column v-for=&quot;item in headerGroupsCol&quot; :key=&quot;item.key&quot; :label=&quot;item.name&quot; :prop=&quot;item.key&quot;&gt;
        &lt;template v-if=&quot;item.children&quot;&gt;
          &lt;el-table-column v-for=&quot;child in item.children&quot; :key=&quot;child.key&quot; :label=&quot;child.name&quot; :prop=&quot;child.key&quot;&gt;
            &lt;template v-if=&quot;child.children&quot;&gt;
              &lt;el-table-column v-for=&quot;grand in child.children&quot; :key=&quot;grand.key&quot; :label=&quot;grand.name&quot; :prop=&quot;grand.key&quot; /&gt;
            &lt;/template&gt;
          &lt;/el-table-column&gt;
        &lt;/template&gt;
      &lt;/el-table-column&gt;
    &lt;/sh-table&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  //   import downloadExcel from '#/utils/xlsx.js'
  const { downloadGroupsExcel } = require('#/utils/xlsx.js')
  export default {
    name: 'downloadExcel',
    data() {
      return {
        tableData: [
          {
            date: '2016-05-03',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-02',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-04',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-01',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-08',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄'
          },
          {
            date: '2016-05-06',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: null
          },
          {
            date: '2016-05-07',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 0
          }
        ]
      }
    },
    computed: {
      headerGroupsCol() {
        return [
          {
            name: '日期',
            key: 'date'
          },
          {
            name: '配送信息',
            children: [
              {
                name: '姓名',
                key: 'name'
              },
              {
                name: '地址信息',
                children: [
                  {
                    name: '省份',
                    key: 'province'
                  },
                  {
                    name: '城市',
                    key: 'city'
                  },
                  {
                    name: '地址',
                    key: 'address'
                  }
                ]
              }
            ]
          },
          {
            name: '邮编',
            key: 'zip'
          }
        ]
      }
    },
    methods: {
      onDownload() {
        downloadGroupsExcel({
          tableData: this.tableData,
          columns: this.headerGroupsCol,
          fileName: '分组表格'
        })
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block></div>
<h3 id="biao-wei-he-ji"><a class="header-anchor" href="#biao-wei-he-ji">¶</a> 表尾合计</h3>
<demo-block>
        
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;download-excel&quot;&gt;
    &lt;div class=&quot;btn-box&quot;&gt;
      &lt;el-button @click=&quot;onFooterDataDownLoad&quot;&gt; 合计数据下载 &lt;/el-button&gt;
    &lt;/div&gt;
    &lt;sh-table :page-show=&quot;false&quot; :data=&quot;tableData&quot; border show-summary :summary-method=&quot;getSummaries&quot; :maxHeight=&quot;500&quot;&gt;
      &lt;template v-for=&quot;item in tableHeader&quot;&gt;
        &lt;el-table-column v-if=&quot;item.children &amp;&amp; item.children.length &gt; 0&quot; :key=&quot;item.label&quot; :label=&quot;item.label&quot; :width=&quot;item.width&quot;&gt;
          &lt;template v-for=&quot;x in item.children&quot;&gt;
            &lt;el-table-column :key=&quot;x.label&quot; :label=&quot;x.label&quot; :prop=&quot;x.key&quot;&gt;&lt;/el-table-column&gt;
          &lt;/template&gt;
        &lt;/el-table-column&gt;
        &lt;el-table-column v-else :key=&quot;item.label&quot; :label=&quot;item.label&quot; :prop=&quot;item.key&quot; :minWidth=&quot;item.minWidth&quot;&gt;&lt;/el-table-column&gt;
      &lt;/template&gt;
    &lt;/sh-table&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  const { downloadGroupsExcel } = require('#/utils/xlsx.js')
  const dataList = require('../json/excel-data.json')
  export default {
    data() {
      return {
        tableData: [],
        tableHeader: [],
        footerData: {}
      }
    },
    mounted() {
      this.getTableList()
    },
    methods: {
      // 模拟后端数据
      getTableList() {
        let res = JSON.parse(JSON.stringify(dataList)).res
        this.setTableHeader(res)
        this.setTableData(res)
      },
      setTableHeader(data = []) {
        if (data.length === 0) return
        this.tableHeader = data.map(x =&gt; {
          return {
            label: x.productDictName,
            name: x.productDictName,
            children: [
              {
                label: '入库件数',
                name: '入库件数',
                key: 'inNum' + x.productDictId
              },
              {
                label: '入库米数',
                name: '入库米数',
                key: 'inLen' + x.productDictId
              },
              {
                label: '出库件数',
                name: '出库件数',
                key: 'outNum' + x.productDictId
              },
              {
                label: '出库米数',
                name: '出库米数',
                key: 'outNum' + x.productDictId
              }
            ]
          }
        })
        this.tableHeader.unshift({
          label: '日期',
          name: '日期',
          key: 'date',
          minWidth: '120'
        })
      },
      setTableData(data = []) {
        if (data.length === 0) return
        this.tableData = data[0].dataList.map(x =&gt; ({
          date: x.belongDate
        }))
        this.tableData.map(x =&gt; {
          data.map(y =&gt; {
            let obj = y.dataList.find(z =&gt; z.belongDate === x.date)
            if (obj) {
              x['inNum' + y.productDictId] = obj.inNum
              x['inLen' + y.productDictId] = obj.inLen
              x['outNum' + y.productDictId] = obj.outNum
              x['outLen' + y.productDictId] = obj.outLen
            }
          })
        })
        // console.log(this.tableData)
      },
      getSummaries(param) {
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) =&gt; {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map(item =&gt; Number(item[column.property]))
          if (!values.every(value =&gt; isNaN(value))) {
            sums[index] = values.reduce((prev, curr) =&gt; {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = '-'
          }
        })
        this.footerData = sums
        return sums
      },

      onFooterDataDownLoad() {
        downloadGroupsExcel({
          tableData: this.tableData,
          columns: this.tableHeader,
          footerData: this.footerData,
          fileName: '1112'
        })
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="biao-tou-fen-zu-lie-he-bing-biao-wei-shu-ju"><a class="header-anchor" href="#biao-tou-fen-zu-lie-he-bing-biao-wei-shu-ju">¶</a> 表头分组列合并表尾数据</h3>
<demo-block>
        
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;footer-excel-box&quot;&gt;
    &lt;div class=&quot;btn-box&quot;&gt;
      &lt;el-button @click=&quot;onDownload&quot;&gt;下载&lt;/el-button&gt;
    &lt;/div&gt;

    &lt;sh-table :page-show=&quot;false&quot; :data=&quot;tableData&quot; border :span-method=&quot;objectSpanMethod&quot; show-summary :summary-method=&quot;getSummaries&quot;&gt;
      &lt;template v-for=&quot;item in tableHeader&quot;&gt;
        &lt;el-table-column v-if=&quot;item.children &amp;&amp; item.children.length &gt; 0&quot; :key=&quot;item.label&quot; :label=&quot;item.label&quot;&gt;
          &lt;template v-for=&quot;child in item.children&quot;&gt;
            &lt;el-table-column :key=&quot;child.label&quot; :label=&quot;child.label&quot; :prop=&quot;child.key&quot;&gt;&lt;/el-table-column&gt;
          &lt;/template&gt;
        &lt;/el-table-column&gt;
        &lt;el-table-column v-else :key=&quot;item.label&quot; :label=&quot;item.label&quot; :prop=&quot;item.key&quot;&gt;&lt;/el-table-column&gt;
      &lt;/template&gt;
    &lt;/sh-table&gt;
    &lt;div class=&quot;total&quot;&gt;
      &lt;div class=&quot;total-item1&quot;&gt;当日总产量&lt;/div&gt;
      &lt;div class=&quot;total-item2&quot;&gt;{{ dayTotal }}&lt;/div&gt;
    &lt;/div&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  // import dataList from '../json/excel-col-json.json'
  // import { downloadGroupsColExcel, formatFixedNoRound } from 'sh-ui-v2'
  const dataList = require('../json/excel-col-json.json')
  const { downloadGroupsColExcel } = require('#/utils/xlsx.js')
  const { formatFixedNoRound } = require('#/utils/index.js')

  export default {
    name: 'FooterExcel',
    data() {
      return {
        tableData: [],
        footerData: [],
        dayTotal: 0
      }
    },
    computed: {
      tableHeader() {
        return [
          {
            label: '姓名',
            name: '姓名',
            key: 'name'
          },
          {
            label: '产量',
            name: '产量',
            children: [
              {
                label: '当日产量',
                name: '当日产量',
                key: 'dailyOutput'
              },
              {
                label: '月度产量',
                name: '月度产量',
                key: 'monthlyOutput'
              }
            ]
          },
          {
            label: '次品率',
            name: '次品率',
            key: 'defectRate'
          },
          {
            label: '设备利用率',
            name: '设备利用率',
            key: 'equipmentUtilization'
          },
          {
            label: '工时',
            name: '工时',
            key: 'workHours'
          },
          {
            label: '单位',
            name: '单位',
            key: 'unit'
          }
        ]
      }
    },
    mounted() {
      this.getTableList()
    },
    methods: {
      getTableList() {
        this.tableData = dataList.res.sort((a, b) =&gt; a.nameId.localeCompare(b.nameId))
        this.getDayTotal()
      },

      objectSpanMethod({ row, column, rowIndex }) {
        const spanMap = {}
        // 预处理：根据 name 分组，记录每组的起始索引和合并行数
        this.tableData.forEach((item, index) =&gt; {
          const name = item.nameId
          if (!spanMap[name]) {
            spanMap[name] = { start: index, span: 1 }
          } else {
            spanMap[name].span++
          }
        })

        const name = row.nameId
        const { start, span } = spanMap[name]

        if (rowIndex === start) {
          // 在起始行显示并合并单元格
          if (column.property === 'name') {
            return {
              rowspan: span,
              colspan: 1
            }
          }
        } else {
          // 其余行隐藏该单元格
          if (column.property === 'name') {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      },
      getSummaries(param) {
        const { columns, data } = param

        const sums = []
        columns.forEach((column, index) =&gt; {
          if (index === 0) {
            sums[index] = '平均值'
            return
          }
          const values = data.map(item =&gt; Number(item[column.property]))
          if (!values.every(value =&gt; isNaN(value))) {
            sums[index] = values.reduce((prev, curr) =&gt; {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] = formatFixedNoRound(sums[index] / data.length)
          } else {
            sums[index] = '-'
          }
        })
        this.footerData = sums
        return sums
      },
      // 计算自定义数据
      getDayTotal() {
        this.dayTotal = this.tableData.map(x =&gt; x.dailyOutput).reduce((a, b) =&gt; a + b, 0)
      },
      onDownload() {
        let footerData = [this.footerData, ['当日总产量', this.dayTotal]]
        downloadGroupsColExcel({
          tableData: this.tableData,
          columns: this.tableHeader,
          mergeKey: 'nameId',
          visibleMergeKey: 'name',
          subMergeKeys: ['unit'],
          footerData: footerData,
          styleCallback: this.excelStyle
        })
      },
      excelStyle(worksheet) {
        let colNum = worksheet.columnCount
        let rowNum = worksheet.rowCount
        const getColumnLetter = colNum =&gt; {
          let temp = ''
          while (colNum &gt; 0) {
            let mod = (colNum - 1) % 26
            temp = String.fromCharCode(65 + mod) + temp
            colNum = Math.floor((colNum - mod) / 26)
          }
          return temp
        }

        const lastColLetter = getColumnLetter(colNum)
        worksheet.mergeCells(`B${rowNum}:${lastColLetter}${rowNum}`)
      }
    }
  }
&lt;/script&gt;

&lt;style lang=&quot;scss&quot;&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="fang-fa"><a class="header-anchor" href="#fang-fa">¶</a> 方法</h3>
<table>
<thead>
<tr>
<th>方法名</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>downloadExcel</td>
<td>下载基础表格</td>
<td>{ tableData: [], columns: [], fileName: '', styleCallback: () =&gt; {},footerData }</td>
</tr>
<tr>
<td>downloadGroupsExcel</td>
<td>下载表头多级分组表格</td>
<td>{ tableData: [], columns: [], fileName: '', styleCallback: () =&gt; {},footerData }</td>
</tr>
<tr>
<td>downloadGroupsColExcel</td>
<td>下载表头多级分组表格，表头合并列</td>
<td>{ tableData: [], columns: [], fileName: '', styleCallback: () =&gt; {},footerData,mergeKey, visibleMergeKey,subMergeKeys }</td>
</tr>
<tr>
<td>downloadColExcel</td>
<td>下载合并列表格,用法同 downloadGroupsColExcel</td>
<td>{tableData:[],columns:[],fileName:'',styleCallback:()=&gt;{},footerData,mergeKey,visibleMergeKey,subMergeKeys}</td>
</tr>
</tbody>
</table>
<h3 id="han-shu-chuan-can"><a class="header-anchor" href="#han-shu-chuan-can">¶</a> 函数传参</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>事例</th>
<th>是否必传</th>
</tr>
</thead>
<tbody>
<tr>
<td>tableData</td>
<td>表格原始数据</td>
<td>参照示例</td>
<td>是</td>
</tr>
<tr>
<td>columns</td>
<td>表头数据</td>
<td>参照示例</td>
<td>是</td>
</tr>
<tr>
<td>fileName</td>
<td>文件名</td>
<td>&quot;文件名&quot;</td>
<td>否</td>
</tr>
<tr>
<td>styleCallback</td>
<td>样式回调函数</td>
<td>-</td>
<td>否</td>
</tr>
<tr>
<td>footerData</td>
<td>表尾数据</td>
<td>参照示例</td>
<td>否</td>
</tr>
<tr>
<td>mergeKey</td>
<td>表头合并主列的 key</td>
<td>参照示例</td>
<td>否</td>
</tr>
<tr>
<td>visibleMergeKey</td>
<td>mergeKey 不展示时的表格映射字段</td>
<td>参照示例</td>
<td>否</td>
</tr>
<tr>
<td>subMergeKeys</td>
<td>其他合并列</td>
<td>参照示例</td>
<td>否</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"download-excel"},[_c('div',{staticClass:"btn-box"},[_c('el-button',{on:{"click":_vm.onDownload}},[_vm._v("下载")])],1),_vm._v(" "),_c('sh-table',{attrs:{"data":_vm.tableData,"pageShow":false,"border":""}},_vm._l((_vm.headerColumns),function(item){return _c('el-table-column',{key:item.key,attrs:{"field":item.key,"label":item.name,"prop":item.key}})}),1)],1)]],2)}
var staticRenderFns = []

  
    const { downloadExcel } = require('#/utils/xlsx.js')
  const democomponentExport = {
    name: 'downloadExcel',
    data() {
      return {
        tableData: [
          { name: '张三', age: 4, sex: '男' },
          { name: '李四', age: 19, sex: '男' },
          { name: '王五', age: 20, sex: '男' }
        ],
        headerColumns: [
          {
            name: '姓名',
            key: 'name'
          },
          {
            name: '年龄',
            key: 'age'
          },
          {
            name: '性别',
            key: 'sex'
          }
        ]
      }
    },
    methods: {
      onDownload() {
        downloadExcel({ tableData: this.tableData, columns: this.headerColumns, fileName: '表格', styleCallback: this.styleCallback })
      },
      styleCallback(worksheet) {
        // 设置数据单元格样式
        worksheet.eachRow((row, rowNum) => {
          // 第1行为表头行
          if (rowNum === 1) {
            this.renderTableHeader(row)
          } else if (rowNum === 3) {
            // 假设第三行是统计行，单独给这一行背景色用来区别
            row.eachCell((cell, rowNumber) => {
              // 设置单元格背景
              cell.fill = {
                type: 'pattern',
                pattern: 'darkVertical',
                fgColor: { argb: '8FBC8F' },
                bgColor: { argb: '8FBC8F' }
              }
              this.renderCell(cell)
            })
          } else {
            row.eachCell((cell, colNum) => {
              this.renderCell(cell)
            })
          }
        })
      },
      // 设置表头自定义样式
      renderTableHeader(row) {
        // 文本样式
        row.font = {
          color: { argb: 'DC143C' },
          bold: true
        }
        // 文本居中
        row.alignment = { horizontal: 'center' }
        // 设置表头列表
        row.eachCell((cell, cellNum) => {
          // 单元格背景
          cell.fill = {
            type: 'pattern',
            pattern: 'darkTrellis',
            fgColor: { argb: 'DEB887' },
            bgColor: { argb: 'DEB887' }
          }
          // 单元格边框
          cell.border = {
            top: { style: 'double', color: { argb: 'FF00FF00' } },
            left: { style: 'double', color: { argb: 'FF00FF00' } },
            bottom: { style: 'double', color: { argb: 'FF00FF00' } },
            right: { style: 'double', color: { argb: 'FF00FF00' } }
          }
        })
      },
      // 正常数据单元格的样式处理
      renderCell(cell) {
        // 将age属性做特殊处理，大于5的值用红色显示，其它用绿色显示
        if (cell._column._key === 'age') {
          if (cell.value <= 5) {
            cell.font = {
              color: { argb: '7FFF00' },
              bold: true
            }
          } else {
            cell.font = {
              color: { argb: 'DC143C' },
              bold: true
            }
          }
        }
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"download-excel"},[_c('div',{staticClass:"btn-box"},[_c('el-button',{on:{"click":_vm.onDownload}},[_vm._v("下载")])],1),_vm._v(" "),_c('sh-table',{attrs:{"data":_vm.tableData,"pageShow":false}},_vm._l((_vm.headerGroupsCol),function(item){return _c('el-table-column',{key:item.key,attrs:{"label":item.name,"prop":item.key}},[(item.children)?_vm._l((item.children),function(child){return _c('el-table-column',{key:child.key,attrs:{"label":child.name,"prop":child.key}},[(child.children)?_vm._l((child.children),function(grand){return _c('el-table-column',{key:grand.key,attrs:{"label":grand.name,"prop":grand.key}})}):_vm._e()],2)}):_vm._e()],2)}),1)],1)]],2)}
var staticRenderFns = []

  
    //   import downloadExcel from '#/utils/xlsx.js'
  const { downloadGroupsExcel } = require('#/utils/xlsx.js')
  const democomponentExport = {
    name: 'downloadExcel',
    data() {
      return {
        tableData: [
          {
            date: '2016-05-03',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-02',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-04',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-01',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 200333
          },
          {
            date: '2016-05-08',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄'
          },
          {
            date: '2016-05-06',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: null
          },
          {
            date: '2016-05-07',
            name: '王小虎',
            province: '上海',
            city: '普陀区',
            address: '上海市普陀区金沙江路 1518 弄',
            zip: 0
          }
        ]
      }
    },
    computed: {
      headerGroupsCol() {
        return [
          {
            name: '日期',
            key: 'date'
          },
          {
            name: '配送信息',
            children: [
              {
                name: '姓名',
                key: 'name'
              },
              {
                name: '地址信息',
                children: [
                  {
                    name: '省份',
                    key: 'province'
                  },
                  {
                    name: '城市',
                    key: 'city'
                  },
                  {
                    name: '地址',
                    key: 'address'
                  }
                ]
              }
            ]
          },
          {
            name: '邮编',
            key: 'zip'
          }
        ]
      }
    },
    methods: {
      onDownload() {
        downloadGroupsExcel({
          tableData: this.tableData,
          columns: this.headerGroupsCol,
          fileName: '分组表格'
        })
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"download-excel"},[_c('div',{staticClass:"btn-box"},[_c('el-button',{on:{"click":_vm.onFooterDataDownLoad}},[_vm._v(" 合计数据下载 ")])],1),_vm._v(" "),_c('sh-table',{attrs:{"page-show":false,"data":_vm.tableData,"border":"","show-summary":"","summary-method":_vm.getSummaries,"maxHeight":500}},[_vm._l((_vm.tableHeader),function(item){return [(item.children && item.children.length > 0)?_c('el-table-column',{key:item.label,attrs:{"label":item.label,"width":item.width}},[_vm._l((item.children),function(x){return [_c('el-table-column',{key:x.label,attrs:{"label":x.label,"prop":x.key}})]})],2):_c('el-table-column',{key:item.label,attrs:{"label":item.label,"prop":item.key,"minWidth":item.minWidth}})]})],2)],1)]],2)}
var staticRenderFns = []

  
    const { downloadGroupsExcel } = require('#/utils/xlsx.js')
  const dataList = require('../json/excel-data.json')
  const democomponentExport = {
    data() {
      return {
        tableData: [],
        tableHeader: [],
        footerData: {}
      }
    },
    mounted() {
      this.getTableList()
    },
    methods: {
      // 模拟后端数据
      getTableList() {
        let res = JSON.parse(JSON.stringify(dataList)).res
        this.setTableHeader(res)
        this.setTableData(res)
      },
      setTableHeader(data = []) {
        if (data.length === 0) return
        this.tableHeader = data.map(x => {
          return {
            label: x.productDictName,
            name: x.productDictName,
            children: [
              {
                label: '入库件数',
                name: '入库件数',
                key: 'inNum' + x.productDictId
              },
              {
                label: '入库米数',
                name: '入库米数',
                key: 'inLen' + x.productDictId
              },
              {
                label: '出库件数',
                name: '出库件数',
                key: 'outNum' + x.productDictId
              },
              {
                label: '出库米数',
                name: '出库米数',
                key: 'outNum' + x.productDictId
              }
            ]
          }
        })
        this.tableHeader.unshift({
          label: '日期',
          name: '日期',
          key: 'date',
          minWidth: '120'
        })
      },
      setTableData(data = []) {
        if (data.length === 0) return
        this.tableData = data[0].dataList.map(x => ({
          date: x.belongDate
        }))
        this.tableData.map(x => {
          data.map(y => {
            let obj = y.dataList.find(z => z.belongDate === x.date)
            if (obj) {
              x['inNum' + y.productDictId] = obj.inNum
              x['inLen' + y.productDictId] = obj.inLen
              x['outNum' + y.productDictId] = obj.outNum
              x['outLen' + y.productDictId] = obj.outLen
            }
          })
        })
        // console.log(this.tableData)
      },
      getSummaries(param) {
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = '-'
          }
        })
        this.footerData = sums
        return sums
      },

      onFooterDataDownLoad() {
        downloadGroupsExcel({
          tableData: this.tableData,
          columns: this.tableHeader,
          footerData: this.footerData,
          fileName: '1112'
        })
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"footer-excel-box"},[_c('div',{staticClass:"btn-box"},[_c('el-button',{on:{"click":_vm.onDownload}},[_vm._v("下载")])],1),_vm._v(" "),_c('sh-table',{attrs:{"page-show":false,"data":_vm.tableData,"border":"","span-method":_vm.objectSpanMethod,"show-summary":"","summary-method":_vm.getSummaries}},[_vm._l((_vm.tableHeader),function(item){return [(item.children && item.children.length > 0)?_c('el-table-column',{key:item.label,attrs:{"label":item.label}},[_vm._l((item.children),function(child){return [_c('el-table-column',{key:child.label,attrs:{"label":child.label,"prop":child.key}})]})],2):_c('el-table-column',{key:item.label,attrs:{"label":item.label,"prop":item.key}})]})],2),_vm._v(" "),_c('div',{staticClass:"total"},[_c('div',{staticClass:"total-item1"},[_vm._v("当日总产量")]),_vm._v(" "),_c('div',{staticClass:"total-item2"},[_vm._v(_vm._s(_vm.dayTotal))])])],1)]],2)}
var staticRenderFns = []

  
    // import dataList from '../json/excel-col-json.json'
  // import { downloadGroupsColExcel, formatFixedNoRound } from 'sh-ui-v2'
  const dataList = require('../json/excel-col-json.json')
  const { downloadGroupsColExcel } = require('#/utils/xlsx.js')
  const { formatFixedNoRound } = require('#/utils/index.js')

  const democomponentExport = {
    name: 'FooterExcel',
    data() {
      return {
        tableData: [],
        footerData: [],
        dayTotal: 0
      }
    },
    computed: {
      tableHeader() {
        return [
          {
            label: '姓名',
            name: '姓名',
            key: 'name'
          },
          {
            label: '产量',
            name: '产量',
            children: [
              {
                label: '当日产量',
                name: '当日产量',
                key: 'dailyOutput'
              },
              {
                label: '月度产量',
                name: '月度产量',
                key: 'monthlyOutput'
              }
            ]
          },
          {
            label: '次品率',
            name: '次品率',
            key: 'defectRate'
          },
          {
            label: '设备利用率',
            name: '设备利用率',
            key: 'equipmentUtilization'
          },
          {
            label: '工时',
            name: '工时',
            key: 'workHours'
          },
          {
            label: '单位',
            name: '单位',
            key: 'unit'
          }
        ]
      }
    },
    mounted() {
      this.getTableList()
    },
    methods: {
      getTableList() {
        this.tableData = dataList.res.sort((a, b) => a.nameId.localeCompare(b.nameId))
        this.getDayTotal()
      },

      objectSpanMethod({ row, column, rowIndex }) {
        const spanMap = {}
        // 预处理：根据 name 分组，记录每组的起始索引和合并行数
        this.tableData.forEach((item, index) => {
          const name = item.nameId
          if (!spanMap[name]) {
            spanMap[name] = { start: index, span: 1 }
          } else {
            spanMap[name].span++
          }
        })

        const name = row.nameId
        const { start, span } = spanMap[name]

        if (rowIndex === start) {
          // 在起始行显示并合并单元格
          if (column.property === 'name') {
            return {
              rowspan: span,
              colspan: 1
            }
          }
        } else {
          // 其余行隐藏该单元格
          if (column.property === 'name') {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      },
      getSummaries(param) {
        const { columns, data } = param

        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '平均值'
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] = formatFixedNoRound(sums[index] / data.length)
          } else {
            sums[index] = '-'
          }
        })
        this.footerData = sums
        return sums
      },
      // 计算自定义数据
      getDayTotal() {
        this.dayTotal = this.tableData.map(x => x.dailyOutput).reduce((a, b) => a + b, 0)
      },
      onDownload() {
        let footerData = [this.footerData, ['当日总产量', this.dayTotal]]
        downloadGroupsColExcel({
          tableData: this.tableData,
          columns: this.tableHeader,
          mergeKey: 'nameId',
          visibleMergeKey: 'name',
          subMergeKeys: ['unit'],
          footerData: footerData,
          styleCallback: this.excelStyle
        })
      },
      excelStyle(worksheet) {
        let colNum = worksheet.columnCount
        let rowNum = worksheet.rowCount
        const getColumnLetter = colNum => {
          let temp = ''
          while (colNum > 0) {
            let mod = (colNum - 1) % 26
            temp = String.fromCharCode(65 + mod) + temp
            colNum = Math.floor((colNum - mod) / 26)
          }
          return temp
        }

        const lastColLetter = getColumnLetter(colNum)
        worksheet.mergeCells(`B${rowNum}:${lastColLetter}${rowNum}`)
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  